import { render, staticRenderFns } from "./hisotorialPagosT.vue?vue&type=template&id=12e5623c&scoped=true"
import script from "./hisotorialPagosT.vue?vue&type=script&lang=js"
export * from "./hisotorialPagosT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e5623c",
  null
  
)

export default component.exports